import React from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Image from '../../Utils/getImage';
import Grid from "@mui/material/Grid2";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const ViewPopup = ({ openviewDialog, setopenviewDialog, selectedBanner }) => {

    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="view-catalogue"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Banner Details
                    <Typography>
                        View the details of the selected banner below.
                    </Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className='view-catalogue-content'>
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                <div className='view-catalogue-image'>
                                    <Image src={selectedBanner?.Bannerimage} alt="Bannerimage" width={190} height={190} />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                <div className='view-catalogue-right'>
                                    <div className='view-catalogue-text'>
                                        <Typography variant='h5'>Banner Name</Typography>
                                        <Typography>{selectedBanner?.name}</Typography>
                                    </div>
                                    <div className='view-catalogue-text'>
                                        <Typography variant='h5'>Status</Typography>
                                        <span style={{
                                            backgroundColor: selectedBanner?.CommonStatus === "Active" ? "#E1FCEF" : "#FFEDEF",
                                            color: selectedBanner?.CommonStatus === "Active" ? "#14804A" : "#D1293D",
                                            padding: "5px 15px",
                                            borderRadius: "5px",
                                            textAlign: "center",
                                            width:'20%'
                                            // cursor: "pointer"
                                        }}>{selectedBanner?.CommonStatus}</span>
                                        {/* <label class="switch">
                                            <input type="checkbox" checked={selectedBanner?.CommonStatus} readOnly />
                                            <span class="slider round"></span>
                                        </label> */}
                                    </div>
                                </div>
                                <div className='view-catalogue-right' style={{ marginTop: 20 }}>
                                    <div className='view-catalogue-text'>
                                        <Typography variant='h5'>created dDate</Typography>
                                        <Typography>{selectedBanner?.createddDate}</Typography>
                                    </div>
                                    <div className='view-catalogue-text'>
                                        <Typography variant='h5'>Updated Date</Typography>
                                        <Typography>{selectedBanner?.UpdatedDate}</Typography>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    )
}

export default ViewPopup;